<template lang="pug">
  v-container
    v-card
      v-card-title
        v-chip(close="" @input="loadStudies" v-model="saved.searchAdvenced.dateFiltred")
          .v-chip__close(style="margin: unset;" @click="addDayDateFilter(-1)")
            v-icon chevron_left
          | {{saved.searchAdvenced.date | formatDate('DDMMYYYY')}}
          .v-chip__close(style="margin: unset;" @click="addDayDateFilter(1)")
            v-icon chevron_right
        v-chip(close="" @input="loadStudies" v-model="saved.searchAdvenced.resourceFiltred")
          | {{ saved.searchAdvenced.resource }}
        v-chip(close="" @input="loadStudies" v-model="saved.searchAdvenced.doctorFiltred")
          | {{ saved.searchAdvenced.doctor }}
        v-chip(close="" @input="loadStudies" v-model="saved.searchAdvenced.statusFiltred")
          | {{ saved.searchAdvenced.status }}
        v-chip(close="" @input="loadStudies" v-model="saved.searchAdvenced.imageFiltred")
          v-icon image
        v-chip(close="" @input="loadStudies" v-model="saved.searchAdvenced.videoFiltred")
          v-icon videocam
        v-chip(close="" @input="loadStudies" v-model="saved.searchAdvenced.roomFiltred")
          v-avatar
            v-icon room
          | {{ saved.searchAdvenced.room }}

        v-spacer
        v-text-field(v-model='saved.search'
          append-icon='search'
          label='Procurar'
          @input="loadStudies"
          hide-details)
        v-menu(:close-on-content-click='false' :nudge-width='200' bottom='' left='' offset-y='')
          v-btn(flat='' icon='' slot='activator')
            v-tooltip(bottom="")
              template(v-slot:activator="{ on }")
                v-icon(v-on="on", medium='') filter_list
              span Filtros
          v-card
            v-list
              v-subheader
                | Filtros
              v-list-tile
                v-list-tile-action
                  v-switch(v-model='saved.searchAdvenced.dateFiltred' @change='loadStudies' color='primary')
                v-list-tile-content
                  date-picker(
                    v-model='saved.searchAdvenced.date'
                    append-icon='calendar_today'
                    label='Data do Exame'
                    :disabled='!saved.searchAdvenced.dateFiltred'
                    @input='loadStudies'
                    hide-details)
              v-list-tile
                v-list-tile-action
                  v-switch(v-model='saved.searchAdvenced.roomFiltred' @change='loadStudies' color='primary')
                v-text-field(v-model='saved.searchAdvenced.room'
                  label='Unidade'
                  @input="loadStudies"
                  append-icon="room"
                  :disabled='!saved.searchAdvenced.roomFiltred')
              v-list-tile
                v-list-tile-action
                  v-switch(v-model='saved.searchAdvenced.doctorFiltred' @change='loadStudies' color='primary')
                v-list-tile-content
                  v-autocomplete(
                    label='Médico'
                    v-model='saved.searchAdvenced.doctor'
                    :items='doctors'
                    :disabled='!saved.searchAdvenced.doctorFiltred'
                    hide-details
                    clearable
                    @change="loadStudies"
                    style='max-width: 229px; padding-top: unset; margin-top: unset;')
              v-list-tile
                v-list-tile-action
                  v-switch(v-model='saved.searchAdvenced.resourceFiltred' @change='loadStudies' color='primary')
                v-list-tile-content
                  v-autocomplete(
                    label='Recurso'
                    v-model='saved.searchAdvenced.resource'
                    :items='resources'
                    :disabled='!saved.searchAdvenced.resourceFiltred'
                    hide-details
                    clearable
                    @change="loadStudies"
                    style='max-width: 229px; padding-top: unset; margin-top: unset;')
              v-list-tile
                v-list-tile-action
                  v-switch(v-model='saved.searchAdvenced.statusFiltred' @change='loadStudies' color='primary')
                v-list-tile-content
                  v-select(
                    label='Status'
                    v-model='saved.searchAdvenced.status'
                    :items='status'
                    :disabled='!saved.searchAdvenced.statusFiltred'
                    hide-details
                    clearable
                    @change="loadStudies"
                    style='max-width: 229px; padding-top: unset; margin-top: unset;')
              v-list-tile
                v-list-tile-action
                  v-switch(v-model='saved.searchAdvenced.imageFiltred' color='primary')
                v-list-tile-title Com imagem
              v-list-tile
                v-list-tile-action
                  v-switch(v-model='saved.searchAdvenced.videoFiltred' color='primary')
                v-list-tile-title Com v&iacute;deo
        v-btn(icon @click="$router.push(`/upload-files`)")
          v-icon(small) upload
      v-data-table.elevation-1(:headers='headers'
        :items='filtredItems'
        :loading='loading'
        :pagination.sync='saved.pagination'
        :rows-per-page-items='rowsPerPage')
        template(slot='items'
          slot-scope='props')
          tr.row-click(@click="$event.target.tagName === 'TD' ? $router.push(`/ultra-fetal/patient/${props.item.patient.id}`) : null")
            td {{ (props.item.studyDate? props.item.studyDate : props.item.date) | formatDate }}
              br
              small {{ props.item.status }}
              v-icon(small v-if='props.item.hasImage') image
              v-icon(small v-if='props.item.hasVideo') videocam
            td {{ getVal(props, 'item.patient.patientName') || getVal(props, 'item.patient.name') }}
              br
              small {{ props.item.patient.patId }}
            td {{ props.item.studies | studiesTitle }}
              br
              small {{ props.item.studies | studiesAn }}
            td {{ props.item.doctor ? props.item.doctor.name : props.item.resource }}
              br
              small {{ props.item.room }}
            td.justify-center.layout.px-0
              v-tooltip(left)
                v-menu(offset-y
                  slot='activator')
                  v-btn.mx-0(slot='activator'
                    icon)
                    v-icon(small)
                      | more_vert
                  v-list
                    v-list-tile(:to="`/patient-portal/${props.item.iuid}`")
                      v-list-tile-content
                        v-list-tile-title Portal do Paciente
                      v-list-tile-action
                        v-btn(icon, ripple, :to="`/patient-portal/${props.item.iuid}`", target="_blank", @click.stop="")
                          v-icon open_in_new
                    v-list-tile(:to="`/ultra-fetal/patient/${props.item.patient.id}`")
                      v-list-tile-content
                        v-list-tile-title Laudo Fetal
                      v-list-tile-action
                        v-btn(icon, ripple, :to="`/ultra-fetal/patient/${props.item.patient.id}`", target="_blank", @click.stop="")
                          v-icon open_in_new
                    v-list-tile(:to="`/general-report/${props.item.iuid}`")
                      v-list-tile-content
                        v-list-tile-title Laudo Geral
                      v-list-tile-action
                        v-btn(icon, ripple, :to="`/general-report/${props.item.iuid}`", target="_blank", @click.stop="")
                          v-icon open_in_new
                    v-list-tile(:to="`/viewer/${props.item.iuid}`")
                      v-list-tile-content
                        v-list-tile-title Imagens
                      v-list-tile-action
                        v-btn(icon, ripple, :to="`/viewer/${props.item.iuid}`", target="_blank", @click.stop="")
                          v-icon open_in_new
                    v-list-tile(:to="`/medical-record/${props.item.iuid}`")
                      v-list-tile-content
                        v-list-tile-title Prontuário
                      v-list-tile-action
                        v-btn(icon, ripple, :to="`/medical-record/${props.item.iuid}`", target="_blank", @click.stop="")
                          v-icon description
                    v-list-tile(@click="onOpenEdit(props.item.iuid)")
                      v-list-tile-content
                        v-list-tile-title Editar
                    v-list-tile(@click="onOpenSendWhatsApp(props.item)")
                      v-list-tile-title Enviar WhatsApp
                span Ações
    UfEditExamDetail(v-model="dialogEdit", :iuid='itemSelect')
    v-dialog(v-model='send.dialog'
      persistent
      max-width='350')
      v-card
        v-card-title.headline Enviar exame por email
        v-card-text.px-4
          v-text-field(v-model='send.email'
            label='Email')
        v-card-actions
          v-spacer
          v-btn(flat
            @click.native='send.dialog = false') Cancelar
          v-btn(color='green darken-1'
            flat
            @click.native='onSend') Enviar
    v-dialog(v-model='send.dialogWhatsApp'
      persistent
      max-width='350')
      v-card
        v-card-title.headline
          v-icon fab fa-whatsapp
          | &nbsp;
          span Enviar Portal do Paciente
        v-card-text.px-4
          v-text-field(v-model='send.phone'
            label='Telefone')
          v-checkbox(
            v-model='send.useProtocol'
            label='Proteger com protocolo de acesso'
            color='primary'
            @change='handleProtocolChange'
          )
          v-alert(
            v-if='send.useProtocol'
            :value='send.protocol'
            type='info'
            outlined
            dense
            color='primary'
            dark
          ).mt-2
            | Protocolo de acesso:
            span.font-weight-bold {{ send.protocol }}
            v-btn(
              icon
              small
              dark
              @click="copyProtocol"
            ).ml-2
              v-icon(small) {{ copied ? 'check' : 'content_copy' }}
        v-card-actions
          v-spacer
          v-btn(flat
            @click.native='send.dialogWhatsApp = false') Cancelar
          v-btn(color='green darken-1'
            flat
            @click.native='onSendWhatsApp'
            :loading='send.loading') Enviar
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import { db } from '@/store/firebase'
import listStatus from '@/utils/reportStatusType'
import firestoreUtil from '@/utils/firestore'
import DatePicker from '@/components/util/DatePicker'

import UfEditExamDetail from '@/components/util/EditExam'

export default {
  name: 'studies',

  components: {
    DatePicker,
    UfEditExamDetail
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
      company: (state) => state.company,
      isAdmin: state => state.user.role === 'admin',
      dataState: (state) => state.studiesState
    }),
    filtredItems: function () {
      let newList = this.saved.items
      if (this.saved.searchAdvenced.videoFiltred) {
        newList = newList.filter(item => item.hasVideo)
      }
      if (this.saved.searchAdvenced.imageFiltred) {
        newList = newList.filter(item => item.hasImage)
      }
      return newList
    },
    doctors () {
      let res = []
      this.saved.items.forEach(item => {
        if (item.doctor && item.doctor.name) res.push(item.doctor.name)
      })
      res = _.uniq(res)
      res = res.sort()
      return res
    },
    resources () {
      let res = []
      this.saved.items.forEach(item => {
        if (item.resource) res.push(item.resource)
      })
      res = _.uniq(res)
      res = res.sort()
      return res
    },
    status () {
      let res = []
      Object.entries(listStatus).forEach(([key, value]) => {
        res.push({ text: _.capitalize(key), value })
      })
      return res
    }
  },

  data () {
    return {
      companies: [],
      itemSelect: '',
      dialogEdit: false,
      headers: [
        { text: 'Data', value: 'date' },
        { text: 'Paciente', value: 'patientName' },
        { text: 'Exame', value: 'title' },
        { text: 'Recurso', value: 'doctor.name' },
        { text: 'Ações', value: 'actions', sortable: false, align: 'center' }
      ],
      loading: true,
      rowsPerPage: [10, 15, 25, 50],
      saved: {
        items: [],
        pagination: {
          descending: true,
          sortBy: 'date',
          rowsPerPage: 10
        },
        search: '',
        searchAdvenced: {
          date: '',
          dateFiltred: true,
          doctorFiltred: null,
          resourceFiltred: null,
          imageFiltred: false,
          videoFiltred: false,
          studiesGrouped: true,
          room: null,
          roomFiltred: false
        }},
      send: {
        dialogWhatsApp: false,
        dialog: false,
        name: '',
        email: '',
        phone: '',
        hashKey: '',
        useProtocol: false,
        protocol: null,
        loading: false
      },
      copied: false
    }
  },

  created () {
    if (this.dataState) {
      this.saved = this.dataState
    } else {
      this.saved.searchAdvenced.date = moment().format('DDMMYYYY')
    }

    const lsFilter = localStorage.getItem(`${this.user.uid}-studies-filter`)
    if (lsFilter) {
      const lsFilterParse = JSON.parse(lsFilter)
      this.saved.searchAdvenced = {
        ...this.saved.searchAdvenced,
        ...lsFilterParse
      }
    }
  },

  beforeDestroy () {
    this.setStudiesState(this.saved)
  },
  mounted () {
    this.loadStudies()
  },

  watch: {
    'saved.pagination': {
      handler: function (val) {
        this.loadStudies()
      },
      deep: true
    },
    dialogEdit (val) {
      if (val === false) this.loadStudies()
    },
    'saved.searchAdvenced': {
      handler: function (val) {
        let payload = Object.assign({}, val)
        delete payload.date
        delete payload.dateFiltred
        localStorage.setItem(`${this.user.uid}-studies-filter`, JSON.stringify(payload))
      },
      deep: true
    }
  },

  methods: {
    ...mapActions(['setStudiesState']),
    addDayDateFilter (days) {
      this.saved.searchAdvenced.date = moment(this.saved.searchAdvenced.date, 'DDMMYYYY').add(days, 'days').format('DDMMYYYY')
      this.loadStudies()
    },
    onOpenEdit (item) {
      this.itemSelect = item
      this.dialogEdit = true
    },
    // Função para gerar protocolo aleatório
    generateProtocol () {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
      let protocol = ''
      for (let i = 0; i < 6; i++) {
        protocol += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return protocol
    },
    async onOpenSendWhatsApp (item) {
      let phone = ''
      await db.collection('patients').doc(item.patient.id).get().then(doc => {
        phone = doc.data().phone
      })
      this.send = {
        hashKey: item.iuid,
        phone: phone,
        name: item.patient.name || item.patient.patientName,
        study: item,
        dialogWhatsApp: true,
        useProtocol: !!item.accessProtocol,
        protocol: item.accessProtocol,
        loading: false

      }
      this.send.study.date = new Date(item.studyDate + 'T00:00:00')
    },
    handleProtocolChange () {
      if (this.send.useProtocol && !this.send.protocol) {
        // Gera novo protocolo ao marcar o checkbox
        this.send.protocol = this.generateProtocol()
      }
    },
    async onSendWhatsApp () {
      this.send.loading = true
      try {
        if (this.send.useProtocol && this.send.protocol) {
          await db.collection('gestationInteraction')
            .doc(this.send.hashKey)
            .update({
              accessProtocol: this.send.protocol
            })
        } else if (!this.send.useProtocol) {
          await db.collection('gestationInteraction')
            .doc(this.send.hashKey)
            .update({
              accessProtocol: null
            })
        }

        const baseUrl = `https://app.ultrahealth.care/#/patient-portal/${this.send.hashKey}`
        const studyDate = this.send.study.date ? this.send.study.date.toLocaleDateString() : ''
        const companyName = this.send.study.company.name
        const textDisponible = this.send.study.status === 'PUBLICADO' ? 'está disponível' : 'estará disponível em breve'

        let message = `Olá, ${this.send.name}! 👋

*${companyName}* informa que seu exame realizado em *${studyDate}* ${textDisponible}. `

        if (this.send.useProtocol) {
          message += `Para acessar seu laudo, imagens e vídeos, utilize seu protocolo de acesso de 6 caracteres:

🔑 *${this.send.protocol}*`
        }
        message += `

Basta clicar no link abaixo para visualizar suas informações:

👉 ${baseUrl}

Qualquer dúvida, nossa equipe está à disposição. 😊

Atenciosamente,
${companyName}.`

        this.send.dialogWhatsApp = false
        window.open(`https://web.whatsapp.com/send?phone=${this.send.phone}&text=${encodeURIComponent(message)}`)
        this.loadStudies()
      } catch (error) {
        console.error('Erro ao enviar WhatsApp:', error)
        this.$swal.fire({
          type: 'error',
          title: 'Erro ao enviar mensagem',
          text: 'Ocorreu um erro ao tentar enviar a mensagem.'
        })
      } finally {
        this.send.loading = false
      }
    },
    loadStudies: _.debounce(function () {
      this.loading = true
      let collectionRef = db.collection('gestationInteraction')
          .where('company.identity', '==', this.company)

      if (this.saved.searchAdvenced.dateFiltred && this.saved.searchAdvenced.date) {
        const momentDate = moment(this.saved.searchAdvenced.date, 'DDMMYYYY').startOf('day')
        const date = momentDate.toDate()
        const dateString = date.toISOString().substring(0, 10)
        // collectionRef = collectionRef.where('date', '==', date)
        if (dateString > '2024-04-04') {
          collectionRef = collectionRef.where('studyDate', '==', dateString)
        } else {
          collectionRef = collectionRef.where('date', '==', date)
        }
      }

      let room = this.saved.searchAdvenced.room
      if (this.saved.searchAdvenced.roomFiltred && room && room !== '') {
        collectionRef = collectionRef.where('room', '==', room.toUpperCase())
      }

      let resource = this.saved.searchAdvenced.resource
      if (this.saved.searchAdvenced.resourceFiltred && resource && resource !== '') {
        collectionRef = collectionRef.where('resource', '==', resource)
      }

      let doctor = this.saved.searchAdvenced.doctor
      if (this.saved.searchAdvenced.doctorFiltred && doctor && doctor !== '') {
        collectionRef = collectionRef.where('doctor.name', '==', doctor)
      }

      let status = this.saved.searchAdvenced.status
      if (this.saved.searchAdvenced.statusFiltred && status && status !== '') {
        collectionRef = collectionRef.where('status', '==', status)
      }

      let q = this.saved.search
      if (q && q !== '') {
        collectionRef = collectionRef
          .where('keywords', 'array-contains', q.toUpperCase())
          .orderBy('patient.patientName')
      } else {
        if (!this.saved.searchAdvenced.dateFiltred) {
          collectionRef = collectionRef
              .orderBy('date', 'desc')
        }
      }

      collectionRef
        .limit(500)
        .get()
        .then(query => {
          this.loading = true
          if (query.empty) {
            if (collectionRef.Sf.filters[1].field.segments[0] === 'studyDate') {
              collectionRef.Sf.filters.splice(1, 1)

              const momentDate = moment(this.saved.searchAdvenced.date, 'DDMMYYYY').startOf('day')
              const date = momentDate.toDate()
              collectionRef = collectionRef.where('date', '==', date)
              collectionRef.limit(500).get().then(query => {
                if (query.empty) {
                  this.saved.items = []
                  this.loading = false
                  return
                }
                this.saved.items = query.docs.map(item => firestoreUtil.docToObject(item))
                this.loading = false
              })
            } else {
              this.saved.items = []
              this.loading = false
            }
          } else {
            this.saved.items = query.docs.map(item => firestoreUtil.docToObject(item))
            this.loading = false
          }
        })
    }, 500),
    copyProtocol () {
      navigator.clipboard.writeText(this.send.protocol)
      this.copied = true
      // Reset do estado após 2 segundos
      setTimeout(() => {
        this.copied = false
      }, 2000)
    }
  }
}
</script>

<style>
  .row-click {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Studies.vue